import { Route } from '@angular/router';
import { UiBreadcrumbItem, UiPageChromeConfig } from '@system-dyg/shared/ui';

const CRM_CRUMB: UiBreadcrumbItem = { id: 'crm', label: 'CRM' };

interface CrmLandingRouteConfig {
  readonly path: string;
  readonly moduleId: string;
  readonly activeMenubarId: string;
  readonly title: string;
  readonly breadcrumbs: readonly UiBreadcrumbItem[];
  readonly loadComponent: NonNullable<Route['loadComponent']>;
  readonly titleBarMode?: UiPageChromeConfig['titleBarMode'];
}

/** Construye una ruta de página CRM con un chrome uniforme. */
export function crmLandingRoute(config: CrmLandingRouteConfig): Route {
  return {
    path: config.path,
    pathMatch: 'full',
    loadComponent: config.loadComponent,
    data: {
      chrome: {
        moduleId: config.moduleId,
        activeMenubarId: config.activeMenubarId,
        title: config.title,
        titleBarMode: config.titleBarMode ?? 'form',
        breadcrumbItems: [CRM_CRUMB, ...config.breadcrumbs],
      } satisfies UiPageChromeConfig,
    },
  };
}
